import { makeVar } from '@apollo/client'
import { EUrls } from 'utils/urls'

export interface IUrlWithFilters {
  pathname: string
  searchQuery: string
}

const lastUrlWithFilters = makeVar<IUrlWithFilters>({
  pathname: '',
  searchQuery: ''
})

export const setLastUrlWithFilters = ({ pathname, searchQuery = '' }: IUrlWithFilters): void => {
  lastUrlWithFilters({
    pathname,
    searchQuery
  })
}

export const getNextLink = (nextPathname: EUrls): string => {
  const url = lastUrlWithFilters()

  if (url.pathname === nextPathname) {
    return `${url.pathname}${url.searchQuery}`
  }

  return nextPathname
}
